<template>
  <table>
    <thead>
      <tr>
        <th v-show="selected[index]"
            v-for="(header, index) in headers"
            :key="index"
            @click="sortBy(header.value)">
          <div class="ticket-header">
            <span>
              {{getHeaderTranslation(header.value)}}
            </span>
            <i class="n-i"
               v-if="sortable && header.value === sortColumn"
               :class="descending ? 'n-i-arrow-down-b2' : 'n-i-arrow-up-b2'">
            </i>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data"
          :key="index">
        <td v-show="selected[index]"
            v-for="(header, index) in headers"
            :key="index"
            @click="getItems(item.id)"
            :class="{'highlight-row': type === 'list' ? setRowBackground(item.id) : false}">
          <i class="ticket-icon"
             v-if="header.betslip && !item.total"
             :class="header.betslip"
             :style="setStatus(item.status)">
          </i>
          <div v-if="type === 'details' && !header.values">
            <span v-if="header.status">
              {{getStatusTranslation(item[header.value])}}
            </span>
            <span v-else>{{item[header.value]}}</span>
          </div>
          <TableBetValues v-if="header.values"
                          :bet-values="item.value">
          </TableBetValues>
          <div v-if="type === 'list' && !header.config">
            <div v-if="isKolor && header.value === 'result'"
                 class="ticket-result">
              <div class="value"
                   :style="{'background-color': getColor(item.color)}">
              </div>
            </div>
            <div v-else>
              {{item[header.value]}}
            </div>
          </div>
          <div class="ticket-status"
               :style="setStatus(item.status)"
               v-if="header.config && !item.total">
            <span>{{getStatusTranslation(item.status)}}</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex';
import { upperFirst, camelCase, lowerCase } from 'lodash';
import TableBetValues from './TableBetValues';
import betParser from '../utility/betParser';

export default {
  name: 'Table',
  components: {
    TableBetValues,
  },
  props: {
    descending: {
      type: Boolean,
    },
    data: {
      type: Array,
    },
    headers: {
      type: Array,
    },
    id: {
      type: Number,
    },
    selected: {
      type: Array,
    },
    sortColumn: {
      type: String,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
  },
  computed: {
    ...mapGetters([
      'isKolor',
      'translation',
      'translations',
    ]),
  },
  methods: {
    getItems(value) {
      if (this.type === 'list') {
        this.$emit('getItems', value);
      }
    },
    getColor(value) {
      return betParser.parseKolorColor(value);
    },
    getHeaderTranslation(value) {
      const key = `tableHeader${upperFirst(value)}Label`;
      return this.translation(key);
    },
    getStatusTranslation(value) {
      const ticketStatus = lowerCase(value) === 'payedout' ? 'PAID OUT' : value;
      const name = upperFirst(camelCase(ticketStatus));
      const key = `ticketStatus${name}`;
      return this.translation(key);
    },
    sortBy(value) {
      if (this.sortable && this.data.length) {
        let sortBy = value;
        if (value === 'status') {
          sortBy = this.$route.name === 'Rounds' ? 'wheelRoundStatusTitle' : 'ticketStatusTitle';
        }
        if (value === 'jackpotWinAmount') {
          sortBy = 'winAmount';
        }
        this.$emit('sortBy', sortBy);
      }
    },
    setRowBackground(value) {
      if (this.type === 'list') {
        return this.id === value;
      }
      return false;
    },
    setStatus(status) {
      switch (status) {
        case 'WON':
          return { 'border-color': '#80c45a', color: '#80c45a' };
        case 'LOST':
          return { 'border-color': '#cd6d6d', color: '#cd6d6d' };
        case 'OPEN':
          return { 'border-color': '#029aff', color: '#029aff' };
        case 'PAID OUT':
          return { 'border-color': '#bbb04c', color: '#bbb04c' };
        default:
          return { 'border-color': '#808b9c', color: '#808b9c' };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  table {
    border-collapse:collapse;
    width: 100%;
    td {
      border: 1px solid #dddddd;
      padding: 9px;
    }
    tr th {
      background-color: #d3dadd;
      font-weight: bold;
      color: #6b7585;
      font-size: 12px;
      height: 34px;
      text-align: center;
      line-height: 1;
      background: $tablePattensBlue;
      border-top-color: $tablePattensBlue;
      border-bottom-color: $tablePattensBlue;
      cursor: pointer;
    }
    tr td {
      border-left: 0;
      border-right: 0;
      background-color: $tableWhite;
      height: 32px;
      font-size: 12px;
      color: #6b7585;
      text-align: center;
      line-height: 1;
      padding: 3px 0;
      cursor: pointer;
    }
    th {
      border-right: 2px solid $tableWhite;
    }
    tbody > tr {
      border-right: 2px solid $tableWhite;
      &:first-child {
        border-top: 10px solid $tableWhite;
       }
      &:last-child > td {
        background-color: $tablePattensBlue;
        pointer-events: none;
      }
      &:nth-last-child(2) {
        border-bottom: 10px solid $tableWhite;
      }
      .highlight-row {
        background-color: $tablePattensBlue;
      }
      .ticket-result {
        display: flex;
        justify-content: center;
        .value {
          width: 20px;
          height: 20px;
          border-radius: 2px;
          margin-left: 2px;
        }
      }
    }
    tr {
      &:hover td {
        background-color: $tablePattensBlue;
      }
    }
    th {
      &:first-child {
        border-left-style: hidden;
      }
      &:last-child {
        width: 25px;
      }
    }
  }

  .ticket-status {
    border: 1px solid;
    height: 25px;
    display: table;
    width: 109px;
    margin: 0 auto;
    background-color: $tableWhite;
    > span {
      display:table-cell;
      vertical-align:middle;
    }
  }

  .ticket-icon {
    font-size: 16px;
  }

  .ticket-header {
    .n-i {
      font-size: 10px;
      padding-left: 5px;
    }
  }
</style>
